"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isValueSelected;
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function isValueSelected(value, candidate) {
    if (candidate === undefined || value === undefined) {
        return false;
    }
    if (Array.isArray(candidate)) {
        return candidate.indexOf(value) >= 0;
    }
    return value === candidate;
}
